import { Spinner } from "@/src/components/design-system/Spinner/Spinner";

export function RouteParamsPendingFallback() {
  return <Spinner size="xl" variant="muted" />;
}
